import animatedTeacher from 'application/learning_groups/animated_teacher_waving_hand.json'
import lottie from 'lottie-web'

class Sofatutor.Classes.Teachers
  constructor: ->
    @cache()
    @bindEvents()
    @initCarousel(@$teachersTestimonialsCarousel, mobileArrows = false)
    @initCarousel(@$teachersHeaderCarousel, mobileArrows = true)
    @initAccordions()
    @toggleOfferType(@getOfferTypeFromActiveTab()) if $('.teachers-page')[0] || $('.teachers-feature-page')[0] || $('.startchancen-page')[0]
    @expandTable() if new RegExp('[\#&_]' + 'license-info').exec(window.location.href)
    @initializePopup()
    @checkActiveTab

    if $('.startchancen-page')[0]
      $('.license-info--schools').removeClass('is-hidden')
      $('.js-expand-table[data-offer-content="school"]').removeClass('is-hidden')

      $schoolFeatureTab = $('.js-show-features[data-features="school"]')
      if $schoolFeatureTab.length
        $schoolFeatureTab.addClass('is-active')

      $schoolTableFeature = $('.js-table-feature[data-features="school"]')
      if $schoolTableFeature.length
        $schoolTableFeature.removeClass('hide-table-feature')

  cache: ->
    @svgContainer                   = $('.js-animation-container')[0]
    @$teachersTestimonialsCarousel  = $('.teacher-testimonials__carousel')
    @$teachersHeaderCarousel        = $('.teacher-header__carousel')
    @$teachersfaqaccordions         = $('.js-teacher-faq-accordion')
    @$mobileTableNavigationTabs     = $('.js-show-features')
    @$tooltip                       = $('.license-info__row .icon--info, button.icon--info')
    @$expandTableButton             = $('.js-expand-table')
    @$offerTabs                     = $('.js-show-offers')
    @$offerContentContainers        = $('.js-show-content-container')
    @$featuresContentContainers     = $('.js-show-features-container')
    @$proofOfOccoupationFaq         = $('.js-scroll-to-proof-of-occupation-faq')
    @$scrollToLicenseInfoTableButton = $('.js-scroll-to-license-info-table')
    @$licenseInfoTeachersTable       = $('.license-info--teachers')
    @$expandFeaturesLink             = $('.teachers-feature-page .js-expand-features-link')
    @$featureCard                    = $('.teachers-feature-page .teacher-feature-page-features-overview-card')

    @$triggerPgtPopup                = $('.js-show-pgt-ratings')
    @$pgtPopup                       = $('#js-pgt-popup')
    @$pgtRatingExpand                = $('.js-pgt-rating-expand')
    @$pgtRatingExpandButton          = $('.js-pgt-rating-expand-button')

  bindEvents: =>
    @$tooltip.foundation()
    @$mobileTableNavigationTabs.on 'click', (e) => @toggleTableFeatures($(e.currentTarget).data('features'))
    @$expandTableButton.on 'click', => @expandTable()
    @$offerTabs.on 'click', (e) => @toggleOfferType($(e.currentTarget).data('offer'))
    @$proofOfOccoupationFaq.on 'click', => @scrollToProofOfOccupationFaq()
    @$scrollToLicenseInfoTableButton.on 'click', => @scrollToLicenseInfoTeachersable()
    @$expandFeaturesLink.on 'click', (e) =>
      @$featureCard.show()
      @$expandFeaturesLink.remove()

    @$triggerPgtPopup.on 'click', => @openPopup()
    @$pgtRatingExpandButton.on 'click', => @pgtRatingExpandReview()

  initializePopup: ->
    return unless @$pgtPopup.length
    @pgtRatingsReveal = new Foundation.Reveal(@$pgtPopup)

  openPopup: ->
    @pgtRatingsReveal.open() if @pgtRatingsReveal

  pgtRatingExpandReview: =>
    @$pgtRatingExpand.show()
    @$pgtRatingExpandButton.hide()

  getOfferTypeFromActiveTab: ->
    activeTab = document.querySelector('.teacher-offers__tab.is-active')
    if activeTab?
      offer = activeTab.getAttribute('data-offer')
      return if offer == 'teacher' || offer == 'school' then offer else 'teacher'
    else
      return 'teacher'

  checkActiveTab: ->
    offer = @getOfferTypeFromActiveTab()

    @toggleOfferType(offer)

  scrollToProofOfOccupationFaq: =>
    new Sofatutor.Classes.ScrollHelper().animateScroll(@$teachersfaqaccordions,600, 200)
    @$teachersfaqaccordions.foundation('down', $('.teacher-faq #faq-proof-of-occupation'))

  scrollToLicenseInfoTeachersable: =>
    @toggleOfferType('teacher')
    new Sofatutor.Classes.ScrollHelper().animateScroll(@$licenseInfoTeachersTable,600, 200)

  initCarousel: (selector, mobileArrows) ->
    unless selector.hasClass('slick-initialized')
      selector.slick(
        dots: true,
        slidesToShow: 1,
        arrows: false,
        prevArrow: '<button><i class="icon icon--arrow-thin icon--rotate-left icon--large"></i></button>'
        nextArrow: '<button><i class="icon icon--arrow-thin icon--large"></i></button>'
        responsive: [
          {
            breakpoint: 959
            settings:
              arrows: mobileArrows
          }
        ]
      )

  initAccordions: =>
    new Foundation.Accordion(@$teachersfaqaccordions)

  toggleTableFeatures: (feature) =>
    @$mobileTableNavigationTabs.removeClass('is-active')
    $(".js-show-features[data-features=#{feature}]").addClass('is-active')
    $('.js-table-feature').addClass('hide-table-feature')
    $(".js-table-feature[data-features=#{feature}]").removeClass('hide-table-feature')
    if feature == 'basic-current' || feature == 'basic-august'
      $(".js-table-feature[data-features='basic']").removeClass('hide-table-feature')

  expandTable: ->
    $('.license-info').removeClass('license-info--fadeout')
    $('.license-info').removeClass('license-info--fadeout')
    $('.js-expand-table').hide()

  toggleOfferType: (offer) =>
    if offer == 'teacher' then @toggleTableFeatures('premium') else @toggleTableFeatures('school-premium')
    $('.js-expand-table').addClass('is-hidden')
    $(".js-expand-table[data-offer-content=#{offer}]").removeClass('is-hidden')
    $('.license-info').addClass('is-hidden')
    $(".license-info[data-offer-content=#{offer}]").removeClass('is-hidden')
    @$offerTabs.removeClass('is-active')
    $(".js-show-offers[data-offer=#{offer}]").addClass('is-active')
    @$offerContentContainers.addClass('is-hidden')
    $(".js-show-content-container[data-offer-content=#{offer}]").removeClass('is-hidden')
    @$featuresContentContainers.addClass('is-hidden')
    $(".js-show-features-container[data-offer-content=#{offer}]").removeClass('is-hidden')

$(document).on 'turbolinks:before-cache', ->
  $('.tooltip').remove()

$(document).on 'turbolinks:before-visit', ->
  Turbolinks.clearCache()

$ ->
  $ ->
  return unless $('.teachers-page')[0] || $('.teachers-feature-page')[0] || $('.startchancen-page')[0]
  new Sofatutor.Classes.Teachers
